import { render, staticRenderFns } from "./RoleResponsiveCard.vue?vue&type=template&id=3b0ea8b6"
import script from "./RoleResponsiveCard.vue?vue&type=script&lang=js"
export * from "./RoleResponsiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports